import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

import I18n from '@app/javascript/i18n/index.js.erb'
import { flashError } from '@app/javascript/classes/flashMessages'

export default class extends Controller {
  static targets = ['form', 'addTagsButton']
  static values = {
    model: String,
    parentElementId: String,
    entityId: String,
    entityIdScoped: String,
    entityType: Number,
    entityName: String
  }

  triggerAddTags() {
    const data = new FormData(this.formTarget)
    const tagType = this.modelValue

    data.append('tags_collection[entity_id]', this.entityIdValue)
    data.append('tags_collection[entity_type]', this.entityTypeValue)
    data.append('tags_collection[entity_name]', this.entityNameValue)
    data.append('tags_collection[tag_type]', this.modelValue)

    this.updateTargetBtn(this.addTagsButtonTarget, I18n.t('search_v2.tags.submit_btn_text'), true)

    Rails.ajax({
      type: 'post',
      url: '/search/tags',
      dataType: 'json',
      data: data,
      success: (data) => this.handleSuccess(data, tagType),
      error: () => {
        flashError('Something went wrong')
        this.updateTargetBtn(this.addTagsButtonTarget, I18n.t(`search_v2.${tagType}.add.btn_text`), false)
      }
    })
  }

  details() {
    const data = new FormData(this.formTarget)
    return { itemIds: data.getAll('tags_collection[issues_ids][]'), itemType: 'Issue' }
  }

  handleSuccess(_data, tagType) {
    this.updateTargetBtn(this.addTagsButtonTarget, I18n.t(`search_v2.${tagType}.add.btn_text`), false)

    this.dispatch(`${this.entityIdScopedValue}:tagsUpdated`, {
      model: this.modelValue,
      parentElementId: this.parentElementIdValue,
      details: this.details()
    })
  }

  dispatch(eventId, payload) {
    // workaround to prefix the events with 'tags:'
    window.dispatchEvent(new CustomEvent(`tags:${eventId}`, { detail: payload }))
  }

  updateTargetBtn(target, text, disabled) {
    target.innerText = text
    target.disabled = disabled
  }
}
